import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { api } from '../Costants';
import { Link } from 'react-router-dom';

function Blog() {
  const [categories, setCategories] = useState([{ id: "All", title: "All" }]);
  const [activeCategory, setActiveCategory] = useState("All");
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch categories from API
  useEffect(() => {
    axios.post(`${api}blog_category_list`)
      .then(res => {
        if (res.data.status === 200) {
          const apiCategories = res.data.records;
          setCategories([{ id: "All", title: "All" }, ...apiCategories]);
        }
      })
      .catch(err => {
        console.error("Error fetching categories:", err);
      });
  }, []);

  // Fetch blog list from API
  useEffect(() => {
    axios.post(`${api}blog_list`)
      .then(res => {
        if (res.data.status === 200) {
          setBlogs(res.data.records);
        }
      })
      .catch(err => {
        console.error("Error fetching blogs:", err);
      })
      .finally(() => setLoading(false));
  }, []);

  // Filter blog data by category
  const filteredData = activeCategory === "All"
    ? blogs
    : blogs.filter(item => item.category_id === activeCategory);

  return (
    <div className="gallery-article-2 pt-50 pb-50">
      <div className="container">
        <div className="row">
          {/* Left Sidebar Filter */}
          <div className="col-lg-3 mb-4">
            <div className="filter-sidebar p-3 border rounded">
              <h5 className="mb-3" style={{ color: "rgb(209 156 105)" }}>Categories</h5>
              <ul className="list-unstyled">
                {categories.map(cat => (
                  <li key={cat.id}>
                    <button
                      className={`filter-btn ${activeCategory === cat.id ? 'active' : ''}`}
                      onClick={() => setActiveCategory(cat.id)}
                    >
                      {cat.title}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Right Gallery */}
          <div className="col-lg-9">
            {loading ? (
              <p>Loading blogs...</p>
            ) : (
              <div className="row">
                {filteredData.length > 0 ? (
                  filteredData.map(item => (
                    <div key={item.id} className="col-lg-4 col-md-6 col-sm-6 mb-4 d-flex">
                      <Link to={`/blog/${item.id}`} className="w-100 text-decoration-none">
                        <div className="gallery-item h-100 d-flex flex-column p-3 shadow rounded">
                          {/* MODIFICATION HERE: Added the 'blog-card-image' class */}
                          <img className="img-fluid blog-card-image" alt={item.title} src={item.image} />
                          <h5 className="mt-3">{item.title}</h5>
                          <p className="content">
                            {item.content.replace(/<[^>]+>/g, '').split(' ').slice(0, 20).join(' ') + '...'}
                          </p>
                        </div>
                      </Link>
                    </div>
                  ))
                ) : (
                  <div className="col-12">
                    <p>No items found in this category.</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Blog;